import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTypesComponent } from './document-types.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddDocumentComponent } from './add-document/add-document.component';
import { EditDocumentComponent } from './edit-document/edit-document.component';
import { DocumentTypeFunctieManagementComponent } from './document-type-functie-management/document-type-functie-management.component';

@NgModule({
    declarations: [
        DocumentTypesComponent,
        AddDocumentComponent,
        EditDocumentComponent,
        DocumentTypeFunctieManagementComponent
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [
        DocumentTypesComponent
    ],
})
export class DocumentTypesModule { }
